import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { change } from 'redux-form'

function Circle (props) {
  const { selected } = props
  return (
    <div className={`of-radio-button__circle ${selected ? 'of-radio-button__circle--selected primary-border-1-100' : 'lines-border-2-100'}`}>
      {selected ? <div className='of-radio-button__circle-inner primary-background-1-100' /> : ''}
    </div>
  )
}

Circle.propTypes = {
  selected: PropTypes.bool
}

function Item (props) {
  const {
    onClick,
    custom,
    label,
    value,
    selected
  } = props
  if (custom) {
    const { left, right } = custom
    return (
      <li
        onClick={() => { onClick(value) }}
        className={`${selected ? 'of-radio-button__item--selected shades-primary-background-1-100 ' : ''}of-radio-button__item clearfix lines-border-1-100`}
        onMouseEnter={e=>{
          const classList = Array.from(e.currentTarget.classList)
          if(!classList.find(i=>i==='shades-primary-background-1-100' && !selected)){
            e.currentTarget.classList.add('shades-primary-background-1-100')
          }
        }}
        onMouseLeave={e=>{
          const classList = Array.from(e.currentTarget.classList)
          if(classList.find(i=>i==='shades-primary-background-1-100') && !selected){
            e.currentTarget.classList.remove('shades-primary-background-1-100')
          }
        }}
      >
        <div className='of-radio-button__left clearfix'>
          <Circle selected={selected} />
          {left()}
        </div>
        <div className='of-radio-button__right clearfix'>
          {right ? right() : ''}
        </div>
      </li>
    )
  }
  return (
    <li onClick={onClick} className={`${selected ? 'of-radio-button__item--selected shades-primary-background-1-100 ' : ''}of-radio-button__item clearfix lines-border-1-100`}>
      <div className='of-radio-button__left clearfix'>
        <Circle selected={selected} />
        <div className='of-radio-button__text text-font-1-100'>{label}</div>
      </div>
    </li>
  )
}

Item.propTypes = {
  onClick: PropTypes.func,
  custom: PropTypes.any,
  label: PropTypes.string,
  value: PropTypes.any,
  selected: PropTypes.any
}

function RadioButton (props) {
  const { list, className, input, initial, meta } = props
  const { name, value } = input
  const { dispatch, form } = meta
  const getFirstItemValue = () => {
    if(list && list.length){
      const firstList = list[0]
      const { value } = firstList
      return value
    }
    return undefined
  }
  const currentValue = value

  const initialValue = initial || getFirstItemValue()



  const handleOnClick = useCallback(value => {
    dispatch(change(form, name, value))
  }, [dispatch, form, name])


  useEffect(() => {
    dispatch(change(form, name, initialValue))
  }, [dispatch, form, name, initialValue])

  const renderList = () => {
    if(list && list.length){
      return list.map((i, index) => {
        const { custom, value, label } = i
        if (custom) {
          return (<Item key={index} onClick={handleOnClick} custom={custom} value={value} selected={currentValue === value} />)
        }
        return (<Item key={index} onClick={handleOnClick} label={label} value={value} selected={currentValue === value} />)
      })
    }
    return (<></>)
  }
  return (
    <div className={`of-radio-button clearfix lines-border-1-100${className ? ' ' + className : ''}`}>
      <ul className='of-radio-button__list clearfix'>
        {renderList()}
      </ul>
      <input type='hidden' readOnly name={name} />
    </div>
  )
}

RadioButton.propTypes = {
  list: PropTypes.any,
  className: PropTypes.string,
  input: PropTypes.any,
  initial: PropTypes.any,
  meta: PropTypes.any
}

export default RadioButton
